/**
 * The figures of the statistics, the French way: « 5,3 % », « +1,1 pt »,
 * « −25 pts », « 6 200 € ».
 */

const format = (value, digits = 0) =>
  value.toLocaleString('fr-FR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
const trim = (value) => value.replace(/,0$/, '');

// A rate is a whole number, but below 10 % a decimal counts.
const digitsOf = (value) => (Math.abs(value) < 10 ? 1 : 0);

export const rate = (part, whole) => (whole > 0 ? (part / whole) * 100 : null);
export const percent = (value) =>
  value == null ? '–' : `${trim(format(value, digitsOf(value)))} %`;
export const euros = (value) => `${format(value)} €`;

// The gap between two rates, in points, between the values shown (« 13 % »
// against « 0 % »: +13 pts, not +12,5).
export const pointsDelta = (current, previous) => {
  if (current == null || previous == null) return null;
  const shown = (value) => Number(value.toFixed(digitsOf(value)));
  const gap = Number((shown(current) - shown(previous)).toFixed(1));
  if (!gap) return { text: '=', tone: 0 };
  const unit = Math.abs(gap) >= 2 ? 'pts' : 'pt';
  return {
    text: `${gap > 0 ? '+' : '−'}${trim(format(Math.abs(gap), 1))} ${unit}`,
    tone: Math.sign(gap),
  };
};

export const countDelta = (current, previous, unit = '') => {
  const gap = current - previous;
  if (!gap) return { text: '=', tone: 0 };
  return {
    text: `${gap > 0 ? '+' : '−'}${format(Math.abs(gap))}${unit}`,
    tone: Math.sign(gap),
  };
};

export const toneClass = (tone) => {
  if (tone > 0) return 'text-green-700';
  if (tone < 0) return 'text-red-700';
  return 'text-gray-400';
};

// What the chart can show; its labels are stats.metric_<key> (the menu) and
// stats.metricTitle_<key> (the title).
export const METRICS = [
  'rdvTaken',
  'calls',
  'pickedUp',
  'discussions',
  'rdvDone',
  'sales',
];

// The four scales of a weekly review, from 1 to 5.
export const FEELINGS = ['confidence', 'questioning', 'objections', 'energy'];

export const STATS_TOTAL_KEYS = [
  'calls',
  'pickedUp',
  'discussions',
  'rdvTaken',
  'rdvDone',
  'rdvNoShow',
  'inbound',
  'sales',
  'revenue',
  'revenueEstimated',
];

// The figures of some days added up (a day not loaded counts for nothing).
export const totalOf = (byDay, days) => {
  const total = Object.fromEntries(STATS_TOTAL_KEYS.map((key) => [key, 0]));
  days.forEach((day) => {
    const row = byDay.get(day);
    if (row) STATS_TOTAL_KEYS.forEach((key) => (total[key] += row[key] ?? 0));
  });
  return total;
};
